import React, { Component } from 'react';
import { connect, ResolveThunks } from 'react-redux';
import RestorePageIcon from '@mui/icons-material/RestorePage';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';

import { NotifierConfirm } from '@paragon/notification-tools';

import { resetAnnotationsForActivePage } from '../../actions/annotationTools';

type DispatchProps = ResolveThunks<typeof actionCreators>;
type Props = DispatchProps;

interface State {
  readonly resetPageOpen: boolean;
}

class ResetPageButton extends Component<Props, State> {
  state: State = {
    resetPageOpen: false,
  };

  onResetPage = () => {
    this.setState({ resetPageOpen: true });
  };

  onConfirmReset = () => {
    this.props.resetAnnotationsForActivePage();
    this.closeResetPage();
  };

  closeResetPage = () => {
    this.setState({ resetPageOpen: false });
  };

  render() {
    return (
      <>
        <Tooltip disableInteractive disableFocusListener id="reset-page-tooltip" title="Reset Page">
          <div>
            <IconButton sx={{ borderRadius: 0, width: '100%' }} aria-label="Reset Page" onClick={this.onResetPage}>
              <RestorePageIcon />
            </IconButton>
          </div>
        </Tooltip>
        <NotifierConfirm
          open={this.state.resetPageOpen}
          onClose={this.closeResetPage}
          onClick={this.onConfirmReset}
          message="Are you sure you want to reset your annotations for this page?"
          buttonText="Reset"
        />
      </>
    );
  }
}

const actionCreators = {
  resetAnnotationsForActivePage,
};

export default connect(null, actionCreators)(ResetPageButton);
